import { render, staticRenderFns } from "./YourTasksTable.vue?vue&type=template&id=28c33c57&scoped=true"
import script from "./YourTasksTable.vue?vue&type=script&setup=true&lang=js"
export * from "./YourTasksTable.vue?vue&type=script&setup=true&lang=js"
import style0 from "./YourTasksTable.vue?vue&type=style&index=0&id=28c33c57&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28c33c57",
  null
  
)

export default component.exports